import React from 'react';
import { Users, Timer, Lock, ShoppingBag, BarChart3, Languages } from 'lucide-react';
import { Panel, PageHeading } from '../ui';
const KPIS = [{
  label: 'WebView sessions (7d)',
  value: '4,812',
  icon: <Users className="h-5 w-5" data-id="element-368" data-mp="zzgg9u3bn1sa" />
}, {
  label: 'Avg load time',
  value: '1.4s',
  icon: <Timer className="h-5 w-5" data-id="element-369" data-mp="v76jpv7pb3h1" />
}, {
  label: 'Locked activity taps',
  value: '1,096',
  icon: <Lock className="h-5 w-5" data-id="element-370" data-mp="19wcf183f49jn" />
}, {
  label: 'Purchases confirmed',
  value: '213',
  icon: <ShoppingBag className="h-5 w-5" data-id="element-371" data-mp="19yfcueatb6yx" />
}];
const FUNNEL = [{
  step: 'Purchase button tapped',
  value: 640,
  pct: 100
}, {
  step: 'Options screen viewed',
  value: 512,
  pct: 80
}, {
  step: 'Licence option tapped',
  value: 358,
  pct: 56
}, {
  step: 'Payment bridge triggered',
  value: 271,
  pct: 42
}, {
  step: 'Payment confirmed',
  value: 213,
  pct: 33
}, {
  step: 'Grant reflected',
  value: 209,
  pct: 33
}];
const LANGS = [{
  code: 'en',
  label: 'English',
  pct: 58,
  color: '#1e2a5a'
}, {
  code: 'hi',
  label: 'हिंदी',
  pct: 27,
  color: '#8E7CA3'
}, {
  code: 'mr',
  label: 'मराठी',
  pct: 15,
  color: '#C08497'
}];
const EVENTS = [{
  name: 'Family App WebView loaded',
  group: 'Session',
  count: 4812
}, {
  name: 'Home screen viewed',
  group: 'Home',
  count: 4520
}, {
  name: 'Playlist opened',
  group: 'Playlist',
  count: 3110
}, {
  name: 'Free activity completed',
  group: 'Playlist',
  count: 1874
}, {
  name: 'Locked activity tapped',
  group: 'Playlist',
  count: 1096
}, {
  name: 'Account created via purchase',
  group: 'Account',
  count: 168
}];
export function AnalyticsDashboard() {
  return <div data-id="element-372" data-mp="1qn8ysnx84ae2">
      <PageHeading title="Analytics Dashboards" subtitle="Only in-WebView events. Native Flutter events (OTP, Razorpay sheet) are tracked separately and out of scope." data-id="element-373" data-mp="1vkhf0iyta4co" />

      <div className="grid grid-cols-2 gap-4 xl:grid-cols-4" data-id="element-374" data-mp="16g778laa70g">
        {KPIS.map(k => <div key={k.label} className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm" data-id="element-375" data-mp="18sxqa53xpp4">
            <div className="flex items-center gap-2 text-[#1e2a5a]" data-id="element-376" data-mp="3u9hdce9sfkcw">
              {k.icon}
              <span className="text-2xl font-bold" data-id="element-377" data-mp="3q95t32lc7m1y">{k.value}</span>
            </div>
            <p className="mt-1 text-xs text-slate-500" data-id="element-378" data-mp="8316aujunpau">{k.label}</p>
          </div>)}
      </div>

      <div className="mt-5 grid gap-5 lg:grid-cols-3" data-id="element-379" data-mp="347st24kbyao">
        <div className="lg:col-span-2" data-id="element-380" data-mp="32mz1eq2ojdv">
          <Panel title="Purchase funnel" icon={<BarChart3 className="h-4 w-4 text-[#1e2a5a]" data-id="element-382" data-mp="h1whym5nxrlj" />} data-id="element-381" data-mp="h3hcibrz9aje">
            <div className="space-y-3 p-5" data-id="element-383" data-mp="d12pdfh9zomb">
              {FUNNEL.map(f => <div key={f.step} data-id="element-384" data-mp="qtse3ro6v7n4">
                  <div className="mb-1 flex justify-between text-xs text-slate-600" data-id="element-385" data-mp="qt0r358nqi8g">
                    <span data-id="element-386" data-mp="lvqvt8yl7ccp">{f.step}</span>
                    <span className="font-semibold text-slate-800" data-id="element-387" data-mp="lwsbjqqjsn0r">
                      {f.value.toLocaleString()} · {f.pct}%
                    </span>
                  </div>
                  <div className="h-2.5 overflow-hidden rounded-full bg-slate-100" data-id="element-388" data-mp="vugf9664t4v2">
                    <div className="h-full rounded-full bg-[#1e2a5a]" style={{
                  width: `${f.pct}%`
                }} data-id="element-389" data-mp="1fex5vzt7f04l" />
                  </div>
                </div>)}
            </div>
          </Panel>
        </div>

        <Panel title="Loaded in language" icon={<Languages className="h-4 w-4 text-[#1e2a5a]" data-id="element-391" data-mp="1ah5b8y16czwp" />} data-id="element-390" data-mp="1aej4h0m3yofj">
          <div className="space-y-4 p-5" data-id="element-392" data-mp="vov2dx63rlqr">
            {LANGS.map(l => <div key={l.code} data-id="element-393" data-mp="10i6cc767oimw">
                <div className="mb-1 flex justify-between text-xs text-slate-600" data-id="element-394" data-mp="10j940hbcyp3v">
                  <span data-id="element-395" data-mp="mrb3guvpq1jb">
                    {l.label}{' '}
                    <span className="font-mono text-slate-400" data-id="element-396" data-mp="rob58tlj4i4m">({l.code})</span>
                  </span>
                  <span className="font-semibold" data-id="element-397" data-mp="cragmyymx3ad">{l.pct}%</span>
                </div>
                <div className="h-2.5 overflow-hidden rounded-full bg-slate-100" data-id="element-398" data-mp="hr6jguvliooc">
                  <div className="h-full rounded-full" style={{
                width: `${l.pct}%`,
                backgroundColor: l.color
              }} data-id="element-399" data-mp="1l1knq8darmku" />
                </div>
              </div>)}
          </div>
        </Panel>
      </div>

      <div className="mt-5" data-id="element-400" data-mp="1b9wtjzpcvrfo">
        <Panel title="Event stream (in-WebView)" icon={<BarChart3 className="h-4 w-4 text-[#1e2a5a]" data-id="element-402" data-mp="16ceh3zc4qu2x" />} data-id="element-401" data-mp="16co6plt9iz83">
          <table className="w-full text-sm" data-id="element-403" data-mp="11emot47kp5y7">
            <thead data-id="element-404" data-mp="11bh2fwqbwi66">
              <tr className="border-b border-slate-200 text-left text-slate-600" data-id="element-405" data-mp="xc86cl7tg87g">
                <th className="px-5 py-3 font-semibold" data-id="element-406" data-mp="xecitrjs6fjc">Event</th>
                <th className="px-5 py-3 font-semibold" data-id="element-407" data-mp="sdf3dmq5nzlj">Group</th>
                <th className="px-5 py-3 text-right font-semibold" data-id="element-408" data-mp="nec12a1k87h9">Count (7d)</th>
              </tr>
            </thead>
            <tbody data-id="element-409" data-mp="2mpv3e5scyhhy">
              {EVENTS.map(e => <tr key={e.name} className="border-b border-slate-100 last:border-0" data-id="element-410" data-mp="2hrtlho6o4o82">
                  <td className="px-5 py-3 font-medium text-slate-800" data-id="element-411" data-mp="2paayw5ho0n6b">
                    {e.name}
                  </td>
                  <td className="px-5 py-3" data-id="element-412" data-mp="2u8md0seztjuc">
                    <span className="rounded-full bg-slate-100 px-2.5 py-0.5 text-xs text-slate-600" data-id="element-413" data-mp="2z0m5y0wnbchf">
                      {e.group}
                    </span>
                  </td>
                  <td className="px-5 py-3 text-right font-mono text-slate-700" data-id="element-414" data-mp="26chzvea5wxe7">
                    {e.count.toLocaleString()}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </Panel>
      </div>
    </div>;
}